import { AxiosResponse } from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import {
    Configuration,
    ResidentsApi,
    SearchResidentLookupDto,
    SearchPropertiesByAddressDto,
    SearchResidentsResponseDto,
    SearchPropertiesResponseDTO,
    PropertiesApi
} from "@inosio/payments-sdk";
import {
    getSearchingResident,
    setSearchingResident,
    getSearchingResidentFailed,
    getSearchingProperty,
    setSearchingProperty,
    getSearchingPropertyFailed,
} from "./invitationSlice";

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestSearchResident(
    searchDTO: SearchResidentLookupDto
) {
    const ipaResidentAPI = new ResidentsApi(apiConfig);
    return ipaResidentAPI.searchResidents(searchDTO);
}
export function requestSearchProperty(
    searchDTO: SearchPropertiesByAddressDto
) {
    const ipaPropertiesAPI = new PropertiesApi(apiConfig);
    return ipaPropertiesAPI.searchProperties(searchDTO);
}
export function* handleSearchResident(action: any) {
    try {
        const response: AxiosResponse<SearchResidentsResponseDto> = yield call(
            requestSearchResident,
            action.payload
        );
        const { data } = response;

        yield put(setSearchingResident(data));
    } catch (error: any) {
        yield put(getSearchingResidentFailed(error?.response?.data));
    }
}
export function* handleSearchProperty(action: any) {
    try {
        const response: AxiosResponse<SearchPropertiesResponseDTO> = yield call(
            requestSearchProperty,
            action.payload
        );
        const { data } = response;

        yield put(setSearchingProperty(data));
    } catch (error: any) {
        yield put(getSearchingPropertyFailed(error?.response?.data));
    }
}
export function* rsInvitationSaga() {
    yield takeLatest(getSearchingResident.type, handleSearchResident);
    yield takeLatest(getSearchingProperty.type, handleSearchProperty);
}
